import { GET_ADD_ONS_SUCCESS } from "../actions/addOnsActions";

const initState = {
  addOns: [],
};

const addOnReducer = (state = initState, action) => {
  if (action.type === GET_ADD_ONS_SUCCESS) {
    return {
      ...state,
      addOns: action.payload,
    };
  }

  return state;
};

export default addOnReducer;
